import axios from "axios";
import Vue from "vue";

async function sendContactFormEmailAsync(body) {
  //set content

  //request
  const subtenantExists = await axios
    .post(`/Email/contactFormular`, body)
    .then(response => {
      return response.data;
    }) 
    .catch((error) => {
      Vue.$log.error(error);
      return null;
    });

  return subtenantExists;
}

export default { sendContactFormEmailAsync };
